export const colors = {
  monocromatic: {
    _100: "272B22",
    _200: "41453D",
    _300: "5C5F58",
    _400: "767973",
    _500: "91938E",
    _600: "ABACA9",
    _700: "C5C6C4",
    _800: "E0E0DF",
    _900: "FAFAFA",
  },

  primary: {
    _100: "223800",
    _200: "39580A",
    _300: "507714",
    _400: "67971E",
    _500: "7eb628",
    _600: "90C83A",
    _700: "A2DB4C",
    _800: "B4ED5E",
    _900: "C6FF70",
  },
};
